import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import GoogleMapReact from "google-map-react";
import { CANDIDATE_NEAR_ME, GOOGLE_PLACES_API_KEY, RECOMMENDED_CANDIDATES, Recruiter_Profile_Status } from "../../../Service/service";
import AddToList from "../../Vaccancy/AddToList";
import MapView from "./MapView";
import RecommendedProfile from "./RecommendedProfile";
// import ApplicantsDetails from "../../Vaccancy/ApplicantsDetails";
import CanNearmeBlackScreen from "./CanNearmeBlackScreen";
import { useTranslation } from "react-i18next";
// import { useContext } from "react";
// import { candata } from "../../../App"; 
import { getData, postData } from "../../../Service/ApiMethod";
import Loader from "../../login/Loader";
// import axios from "axios";


const ListView = (props) => {
  const [popup, setPopup] = useState(false);
  const [data, setData] = useState()
  const [locationTitle, setLocationTitle] = useState()
  const [updateChanges, setUpdateChanges] = useState(false)

  const [blackScreen, setBlackScreen] = useState(false)
  const [candIndexing, setCandIndexing] = useState()
  const [ATLIndexing, setATLIndexing] = useState()
  const [popupp, setPopupp] = useState(false)
  const [distance, setDistance] = useState()
  // const { newData, setNewData } = useContext(candata)
  const navigate = useNavigate()
  const location = useLocation();
  // const data = location?.state?.data
  console.log('List view location Data', location?.state?.distance);
 
  console.log('locationTitle', locationTitle)

  // const defaultProps = {
  //   center: {
  //     lat: localStorage.getItem("latitude"),
  //     lng: localStorage.getItem("longitude"),
  //   },
  //   zoom: 11,
  // };

  // const executeScroll = () => {
  //   console.log('hello')
  //   document.getElementById('HEADER').scrollIntoView(-100, -20);
  //   // myRef.current.scrollTo(200, 0) 
  //   // window.scrollTo(200, 0);
  // }



  useEffect(() => {
    profile_Status()
    

  }, [popupp, updateChanges])

  const getList = () => {
    const obj = {
      radius: distance,
    }
    console.log("asddddaaaaaaaaaa",obj)
    // if(obj.radius == undefined){
    //   setData(undefined)
    // }
    postData(obj, CANDIDATE_NEAR_ME)
      .then((response) => response.json())
      .then((data) => {
        setData(data)
        console.log(data, "cannnnnn")
      })
      .catch((err) => {
        console.log('Error', err);
      })
  }

  useEffect(()=>{
    profile_Status()
    getRecommendedCandidates()

  },[])


  useEffect(() => {
    setData(location?.state?.data)
    setLocationTitle(location?.state?.title)
    setDistance(location?.state?.distance)

  }, [location?.state?.data])

  useEffect(() => {
    setData(location?.state?.data)
    setLocationTitle(location?.state?.title)
  }, [updateChanges])

  useEffect(() => {
    setData(location?.state?.data)
    setLocationTitle(location?.state?.title)
  }, [popupp])


  // useEffect(() => {
  //   setData(location?.state?.data)
  //   setLocationTitle(location?.state?.title)
    
  // }, [newData])

  // useEffect(()=>{
  // executeScroll()
  // },[])



  console.log("data?.data", data?.data)
  console.log("distance", distance)

  const [loaderStart, setLoaderstart] = useState(false)
  const { t } = useTranslation();
  const [listView, setListview] = useState([])
  const List = useRef([])
  const latss = useRef("")
  const longs = useRef("")
  const isSub = useRef(false)
  const profile_Status = () => {
    getData(Recruiter_Profile_Status)
      .then((response) => response.json())
      .then((res) => {
        console.log(res,"cdddd",location?.state?.distance);
        // setLoaderstart(false)
        console.log("res?.data?.is_subscribed == false",res?.data?.is_subscribed)
        if (res?.data?.is_subscribed == true) {
          if(location?.state?.distance != undefined){
            console.log("ddddddddddddd")
            getList()
          }else{
            getRecommendedCandidates()
          }
          
        }
        isSub.current = res?.data?.is_subscribed
        let lat = res?.data?.latitude
        let long = res?.data?.longitude
        latss.current = res?.data?.latitude
        longs.current = res?.data?.longitude
        if (res?.data?.is_subscribed == false) {
          console.log("saaaaaaaaa");
          cateGroup(lat, long)
          cateGroups(lat, long)
        } else {
          // getList()
        }
      })
      .catch((err) => {
        // setLoaderstart(false)
        console.log("profileStatusErr");
      });
  };












  const cateGroup = async (currentLatitude, currentLongitude) => {
    setLoaderstart(true);
  
    var request = {
      radius: location?.state?.distance,
      "latitude": currentLatitude,
      "longitude": currentLongitude
    };
    setTimeout(() => {
       fetch("https://api.catzapp.com/recruiter/countseekers_by_category/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
      },
      body: JSON.stringify(request),
    })
      .then((response) => response.json())
      .then((res) => {
        setLoaderstart(false);
        console.log(res,"checkkkkkkkqqq")
        setListview(res.data)
        List.current = res.data
      })
      .catch(error => {setLoaderstart(false) });
    }, 1000)
  }

 
const [recomended,setRecommendedCandidates] = useState()
 const getRecommendedCandidates = () => {
    getData(RECOMMENDED_CANDIDATES) 
      .then((response) => response.json())
      .then((data) => {
        console.log("recruiter/RecommendedCandidate/00000",data );
          setRecommendedCandidates(data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
        
      });
  };

// const groupValu = useRef([])
  const cateGroups = async (currentLatitude, currentLongitude) => {
    var token = await localStorage.getItem("catzapp_token")
    var request = {
      radius: location?.state?.distance,
      "latitude": currentLatitude,
      "longitude": currentLongitude
    };
    let lastUrl = "recruiter/seekers_list_by_category/"
    console.log(request, "dxxxxxxxxx", lastUrl);
    fetch("https://api.catzapp.com/recruiter/seekers_list_by_category/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
      },
      body: JSON.stringify(request),
    })
      .then((response) => response.json())
      .then((res) => {
        setLoaderstart(false);
        console.log(res,"checkkkkkkkqqq")
        setData(res)
      })
      .catch(error => {setLoaderstart(false) });

  }








  return (
    <>
      {
        loaderStart == true ? (<Loader />) : null
      }
      {console.log(props?.map, "Map map view")}
      {props?.map ? (
        <MapView userMap={location?.state?.distance == undefined? recomended:data} updateChanges={updateChanges} setUpdateChanges={setUpdateChanges} checkSub={isSub.current} rang={location?.state?.distance}/>
      ) : (
        (locationTitle && (locationTitle == 'Candidate Near Me')) ?
          (isSub.current == false ? (<>
            {
              List.current.length != 0 ? (<div className="mt-3 row">
                {
                  List.current?.map((item, index) => (
                    <div
                      className="col-lg-4 col-md-4 col-sm-6 col-12"
                      onClick={() => {

                        navigate('/subcription')
                      }}
                    >
                      <div className="recommended-profile"
                      >
                        <div className="row">
                          <div className="d-flex justify-content-center">
                            <div className="profile-img-box">
                            <img src={item?.category_icon || "../images/Vector.png"} alt="" className="profile-img" />
                            </div>
                          </div>
                          <div className="d-flex flex-column align-items-center">
                            <h2 className="card-heding ">
                            
                                {item?.category_name}
                            
                            </h2>
                            <p className="designation">{item?.rec_cnt} {item?.rec_cnt == 1 ? "candidate" : "candidates"} </p>
                          </div>
                          <div className="d-flex justify-content-center">
                            <img className="padlockimg" src="../images/padlock.png" alt="" ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                }</div>) : (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px', color: 'grey', marginTop: "100px", marginBottom: "100px" }}>{t('No Data Found')}</div>)
            }
          </>) :
            (data?.data.length != 0 ? 
              data?.data?.map((item, index) => (
                <div
                  className="col-lg-4 col-md-4 col-sm-6 col-12"
                  // id={item.id}
                  key={index}
                >
                  <div className="recommended-profile"
                    onClick={(e) => {
                      e.stopPropagation()
                      setBlackScreen(true)
                      console.log(item,"cddssssaasssdd")
                      setCandIndexing(index)
                    }}
                  >
                    <div className="row">
                      <div className="col-lg-4 col-md-12 col-sm-12 px-0 relative flex-center">



                        {/* {item?.is_premium &&
                          <div className="premium-tag-outer" style={{}}>
                            <img
                              src="./images/premium-tag.png"
                              className="premium-tag"
                              // title="Call"
                              alt=""
                            />
                          </div>
                        } */}



<div className="profile-img-box">
                        <img src={item?.image || "../images/Vector.png"} alt="" className="profile-img" />
                        </div>
                        {/* <img
                    src="./images/save-profile.png"
                    alt=""
                    className="save-profile"
                    style={{ cursor: "pointer" }}
                  /> */}
                        {/* {props.bottom} */}
                      </div>
                      <div className="col-lg-8 col-md-12 col-sm-12 pr-0 mt-sm-2">
                        <h2 className="card-heding relative">
                          <span
                            style={{ cursor: "pointer" }}
                          //   onClick={() => props.openDetailPopup()}
                          >
                            {item?.first_name + " " + item?.last_name}
                          </span>
                          <img
                            src="./images/send-job.png"
                            alt=""
                            className="addprofile"
                            onClick={(e) => {
                              e.stopPropagation()
                              setATLIndexing(index)
                              setPopup(true);
                            }}
                            style={{}}
                          />
                          {/* {item?.is_verified ? (
                      <>
                        <img src="./images/verified.png" alt="" />
                        <span className="verified">Verified</span>
                      </>
                    ) : null} */}
                        </h2>
                        <p className="designation">{item?.profile_title}</p>
                        {(parseInt(item?.availability)) > 0 &&
                          <p className="profile-availbility">
                            ({t('Available')} {item?.availability})
                          </p>
                        }

                        <div className="row mt-2">
                          <div className="col-6 px-0">
                            <p className="card-subHeading">{t('Total Experience')}</p>
                            <p className="card-subHeading">{t('Current Location')}</p>
                            <p className="card-subHeading">{t('Package')}</p>
                            <p className="horizontal-center">
                              <img
                                src="./images/match-badge.png"
                                className="img-size18"
                                alt="hi"
                              />
                              <span className="ms-1 match-profile">
                                {parseInt(item?.percentage_match)}% {t('Match')}
                              </span>
                            </p>
                          </div>
                          <div className="col-6 px-0">
                            <p className="profile-info">{item?.experience} {parseInt(item?.experience) > 1 ? 'Years' : 'Year'}</p>
                            <p className="profile-info">{parseInt(item?.distance)} {t('KM Away')} </p>
                            {/* <p className="profile-info">
                              {item?.currency} {item?.expected_salary} {item?.compensation_details}</p> */}
                            {/* <p className="profile-last-seen">
                              <span className="last-seen">{t('Last Seen')}</span>
                              <span style={{ color: 'blue' }}>{item?.last_seen} {t('ago')}</span>
                            </p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {popup && (ATLIndexing == index) && (
                    <AddToList
                      // playlist={playlist}
                      closePopup={() => {
                        console.log(item,"dsdsdsdsfsfsf")
                        setPopup(false);
                      }}
                      seekerID={item?.id}
                    />
                  )}
                  {(candIndexing == index) && blackScreen &&
                    <div className='blur-screen-full-area flex-center ' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', overflow: 'auto', background: 'rgb(0, 0, 0, 0.7' }} >
                      <CanNearmeBlackScreen setPopupp={setPopupp} popupp={popupp} single_applicants_details={item} setBlackScreen={setBlackScreen} />
                    </div>
                  }
                </div>
              ))
              : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px', color: 'grey', marginTop: "100px", marginBottom: "100px" }}>{t('No Data Found')}</div>)
          ) : <div className="row mt-3">
            <RecommendedProfile />
          </div>)
      }

    </>
  );
};

export default ListView;

// const AnyReactComponent = (text) => {
//   return (
//     <div>
//       <img src="../images/blankProfile.png" className="text-danger" />
//       <h4 className="text-danger">{text}</h4>
//     </div>
//   );
// };
